import React, { useEffect, useRef } from 'react';
// Change to import full Swiper package with modules
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Add custom CSS
const styles = {
  servicesCarouselWrap: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative'
  },
  swiperContainer: {
    width: '100%',
    height: 'auto',
    overflow: 'hidden'
  },
  serviceItem: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px',
    height: '350px' // Fixed height for all items
  },
  serviceItemContents: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    padding: '20px',
    background: 'rgba(0,0,0,0.7)',
    zIndex: '2'
  },
  serviceItemCategory: {
    color: '#f8f9fa',
    fontSize: '14px',
    display: 'block',
    marginBottom: '8px'
  },
  serviceItemTitle: {
    color: 'white',
    fontSize: '24px',
    margin: '0'
  },
  serviceItemImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  navigationButton: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: 'white',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: '10'
  }
};

const ServicesCarousel = () => {
  const swiperContainerRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    // Make sure DOM has loaded
    if (swiperContainerRef.current) {
      // Initialize Swiper when component mounts
      swiperInstanceRef.current = new Swiper(swiperContainerRef.current, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.js-custom-next',
          prevEl: '.js-custom-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    }

    // Cleanup when component unmounts
    return () => {
      if (swiperInstanceRef.current && typeof swiperInstanceRef.current.destroy === 'function') {
        swiperInstanceRef.current.destroy();
      }
    };
  }, []);

  const serviceItems = [
    { title: 'Chia Seeds', image: 'assets/img/Website media/Chia Seeds/Ch7.jpeg' },
    { title: 'Flax Seeds', image: 'assets/img/Website media/Flax Seeds/Flx5.jpeg' },
    { title: 'Quinoa', image: 'assets/img/Website media/Quinoa/Qna3.jpeg' },
    { title: 'Moringa', image: 'assets/img/Website media/Moringa/Mor3.jpeg' },
    { title: 'Avocado', image: 'assets/img/Website media/Avocado/Avo1.jpeg' },
    { title: 'Macadamia Nuts', image: 'assets/img/Website media/Macadamia/Mac3.jpeg' },
    { title: 'Mushrooms', image: 'assets/img/Website media/Mushrooms/Mush4.jpeg' },
    { title: 'Bell Pepper', image: 'assets/img/New/Bell Pepper.jpg' },
    { title: 'Chilli Pepper', image: 'assets/img/New/Chilli pepper.jpg' },
    { title: 'Legumes', image: 'assets/img/New/Legumes 2.jpg' },
    { title: 'Legumes', image: 'assets/img/New/Legumes.jpg' },
    { title: 'Managu', image: 'assets/img/New/Managu.jpg' },
    { title: 'Saga', image: 'assets/img/New/Saga.jpg' },
    { title: 'Terere', image: 'assets/img/New/Terere.jpg' },
    
    
  ];

  return (
    <section id="services-2" className="services-2 section dark-background py-5">
      {/* Section Title */}
      <div className="container section-title text-center mb-5" data-aos="fade-up">
        <h2 className="mb-3">Services</h2>
        <p>Zao Afrika Superfood Portfolio</p>
      </div>
      {/* End Section Title */}
      
      <div className="services-carousel-wrap" style={styles.servicesCarouselWrap}>
        <div className="container">
          <div className="swiper-container" ref={swiperContainerRef} style={styles.swiperContainer}>
            <button 
              className="navigation-prev js-custom-prev position-absolute start-0 top-50 translate-middle-y border-0 ms-3" 
              style={styles.navigationButton}
              aria-label="Previous slide"
            >
              <i className="bi bi-arrow-left-short fs-3"></i>
            </button>
            <button 
              className="navigation-next js-custom-next position-absolute end-0 top-50 translate-middle-y border-0 me-3" 
              style={styles.navigationButton}
              aria-label="Next slide"
            >
              <i className="bi bi-arrow-right-short fs-3"></i>
            </button>
            
            <div className="swiper-wrapper">
              {serviceItems.map((item, index) => (
                <div className="swiper-slide" key={index}>
                  <div style={styles.serviceItem}>
                    <div style={styles.serviceItemContents}>
                      <a href="/service" className="text-decoration-none">
                        <span style={styles.serviceItemCategory}>We do</span>
                        <h2 style={styles.serviceItemTitle}>{item.title}</h2>
                      </a>
                    </div>
                    <img 
                      src={item.image} 
                      alt={item.title} 
                      style={styles.serviceItemImage}
                    />
                  </div>
                </div>
              ))}
            </div>
            
            <div className="swiper-pagination mt-4"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCarousel;